module.exports = __webpack_public_path__ + "static/media/share-white.3d395fde.png";